import type { ShippingChargePromo } from '../../../../modules/api';
import { PromoBanner, StrikePrice, regularFees } from '../../../../modules/shippingPromo';

export interface PaymentPromoProps {
  promo: ShippingChargePromo;
  /** The delivery was canceled or refunded: the banner keeps the promotion's
   *  name but claims no saving. */
  refunded?: boolean;
}

/**
 * What a promotion did to a delivery that was already charged: the banner that
 * names it, and the regular shipping + handling the player did not pay, struck
 * through. The rows below stay what was charged.
 */
export function PaymentPromo({ promo, refunded = false }: PaymentPromoProps) {
  const regular = regularFees(promo);

  return (
    <>
      <PromoBanner label={promo.label} discount={promo.discount} mode={refunded ? 'refunded' : 'charged'} />
      {regular !== null && (
        <div className="flex items-center justify-between text-[14px]">
          <span className="opacity-60">Regular shipping + handling</span>
          <StrikePrice amount={regular} />
        </div>
      )}
    </>
  );
}
